
import React, { useState, useEffect, ChangeEvent } from "react";
import Sidebar from "../../components/sidebar";
import UserListItem from "./users_table";
import { getStoredUserData, getUserSession } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import { ApiClient } from "../../utils/apiclient";
import PageControl from "../../components/page_control";
import Spinner from "../../components/spinner";
import { ISelectOption, User } from "../../utils/types";
import TopStrip from "../../components/top_strip";
import { Dialog, DialogContent, DialogTitle, DialogContentText, DialogActions } from "@material-ui/core";
import Select from "react-select";

const Users = (_props: any) => {
  const navigate = useNavigate();
  const notifications = []
  const userData = getStoredUserData();
  const session = getUserSession();
  const apiClient = new ApiClient(session?.accessToken || '');

  const [activeUsers, setActiveUsers] = useState<User[]>([])
  const [filteredUsers, setFilteredUsers] = useState<User[]>(activeUsers)
  const [pageInfo, setPageInfo] = useState<any>({ totalPages: 0, totalCount: 0, currentPage: 1, pageSize: 15, hasNext: false, hasPrevious: false });
  const [pageSize, setPageSize] = useState<number>(20)
  const [page, setPage] = useState<number>(1)
  const [loading,setLoading] = useState<boolean>(false);
  const [deletedUsers, setDeletedUsers] = useState<User[]>([])
  const [selectedDeletedUser, setSelectedDeletedUser] = useState<ISelectOption | null>(null);
  const [showRestoreDialog, setShowRestoreDialog] = useState<boolean>(false);

  const showNotifications = () => {
    navigate(`/notifications/${_props.user?.id}`)
  }
  const handleClickNew = () => {
    navigate('/users/new')
  }
  const getPreviousPage = () => {
    setPage(page - 1)
  }
  const getNextPage = () => {
    setPage(page + 1);
  }
  const getUsers = async (pageSize: number, page: number) => {
    setLoading(true);
    const response = await apiClient.getUsers({ page: page, take: pageSize });
    if (response.status == 200) {
      const data = response.data;
      setPageInfo({ totalPages: response.data.totalPages, totalCount: response.data.totalCount, currentPage: response.data.page, pageSize: response.data.pageSize, hasNext: response.data.hasNext, hasPrevious: response.data.hasPrevious })

      setActiveUsers(data.users);
      setFilteredUsers(data.users);
    }
    setLoading(false);
  }

  const getDeletedUsers = async () => {
    const response = await apiClient.getDeletedUsers();
    console.log("🚀 ~ getDeletedUsers ~ response:", response.data)
    if (response.status == 200) {
      setDeletedUsers(response.data);
    }
  }
  const handleDeletedUserChange = (selectedOption: ISelectOption | null) => {
    setSelectedDeletedUser(selectedOption);
  }
  const handlePageSizeChange = (pageSize: number) => {
    if (pageSize && pageSize >= 10) {
      setPageSize(pageSize);
      setPage(1)
    }
    else {
      setPageSize(10);
      setPage(1);
    }
  }

  const restoreUser = (userId: number) => async () => {
    if (userId) {
      const response = await apiClient.restoreUser(userId);
      if (response.status == 200) {
        alert('User restored successfully');
        getUsers(pageSize, page);
        setShowRestoreDialog(false);
      } else {
        alert('An error occurred while restoring the user. Please try again.');
      }
    } else {
      alert('Please select a user to restore.');
    }
  };

  const handleFilter = async (e: ChangeEvent<HTMLInputElement>) => {
    let keyword = e.currentTarget.value.trim();
    if( keyword.length > 1) {
      keyword = keyword.toLowerCase();
    let result = activeUsers.filter((user:User) => user?.fname?.toLowerCase().includes(keyword)
      || user?.lname?.toLowerCase().includes(keyword)
      || user?.username?.toLowerCase().includes(keyword)
      || user?.position_detail?.value?.toLowerCase().includes(keyword)
      || user?.region?.toLowerCase().includes(keyword)
      || user?.email?.toLowerCase().includes(keyword)
      || user?.phone?.toLowerCase().includes(keyword)
      || user?.location?.toLowerCase().includes(keyword)
      || user?.dept_code?.toLowerCase().includes(keyword))
    setFilteredUsers(result);
    }
    else{
      setFilteredUsers(activeUsers);
    }
  }
  useEffect(() => {
    getUsers(pageSize, page)
    getDeletedUsers()
  }, [pageSize, page])
  return (
    <>
      <div className='w-full flex justify-end items-center bg-gray-100 pe-4'>
        <TopStrip user={userData} />
      </div>
      <main className='w-full flex bg-white min-h-full'>
        <div className='md:w-2/12 flex flex-col items-start text-center justify-center'>
          <Sidebar
            notificationCount={notifications.length}
            user={userData}
            active={2}
          />{' '}
          f
        </div>

        <div className='md:w-9/12 mx-auto space-y-4 mt-2'>
          <div className='flex space-x-2 w-full my-2 pb-2 items-center justify-between border-b-2'>
            <div className='w-full flex items-center justify-start space-x-2'>
              <button
                className='bg-primaryLight text-textDefault hover:bg-accentDark hover:text-white px-2 py-2 w-2/12'
                onClick={handleClickNew}>
                New User
              </button>
              <button className='bg-primaryLight text-textDefault hover:bg-accentDark hover:text-white px-2 py-2 w-2/12' onClick={() => setShowRestoreDialog(true)}>
                Restore User
              </button>
            </div>
          </div>
          <div className='w-full text-textDefault mt-2'>
            <div className='w-full flex items-center justify-between pt-2'>
              <p className='text-2xl font-bold'>Users</p>
              <div className='w-full md:w-4/12'>
                <input
                  type='text'
                  onChange={handleFilter}
                  className='form-control w-6/12'
                  placeholder='search by name or position'
                />
              </div>
            </div>
            {loading ? (
              <Spinner className='spinner-md' />
            ) : (
              <>
                <div className='w-full border-top flex-row flex-start bg-main-color align-items-center '>
                  <PageControl
                    pageSize={pageSize}
                    onNext={getNextPage}
                    onPrevious={getPreviousPage}
                    currentPage={page}
                    totalPages={pageInfo.totalPages}
                    onPageSizeChange={(pageSize: number) => {
                      handlePageSizeChange(pageSize);
                    }}
                    hasNext={pageInfo.hasNext}
                    hasPrevious={pageInfo.hasPrevious}
                  />
                </div>
                <UserListItem users={filteredUsers} />
              </>
            ) }
            {/* Restore User Dialog */}
            <Dialog
              open={showRestoreDialog}
              onClose={() => setShowRestoreDialog(false)}>
              <DialogTitle>Restore User</DialogTitle>
              <div className='p-4 w-full'>
                {/* <p>Select a user to restore:</p> */}
              </div>
              <DialogContent>
                <DialogContentText>
                  Restoring a user will reinstate their access to the system and
                  all associated data. Please ensure you select the correct user
                  to avoid any unintended changes.
                </DialogContentText>
                <div className="h-60">
                  <Select
                    onChange={(e: any) => handleDeletedUserChange(e)}
                    className='form-control'
                    name='user'
                    value={selectedDeletedUser}
                    id='user'
                    options={deletedUsers.map((d: any) => {
                      return {
                        value: d.id,
                        label: d.fname + ' ' + d.lname,
                      };
                    })}
                  />
                </div>
              </DialogContent>
              <DialogActions>
                <button
                  onClick={() => setShowRestoreDialog(false)}
                  className='text-accent'>
                  Cancel
                </button>
                <button
                  onClick={restoreUser(selectedDeletedUser?.value as number)}
                  className='bg-accent text-white px-4 py-2'>
                  Restore
                </button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      </main>
    </>
  );
}

export default Users;